import React from "react";
import { Link } from "react-router-dom";
import Scheduler, { Resource } from "devextreme-react/scheduler";
import { useAuth } from "../../../contexts/auth";
import { axios, PriorityColorData } from "../../../common";

const currentDate = new Date();

export default function SchedulerEventPage() {
  const [data, setData] = React.useState([]);
  const { user } = useAuth();

  React.useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(
        `SchedulerEvent(${user && user.EmployeeOid})`
      );
      setData(data);
    };
    fetchData();
  }, [user]);

  return (
    <div>
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>Scheduler Event List</div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/default" className={"breadcrumb-item"}>
            Default
          </Link>

          <span className={"breadcrumb-item active"}>Scheduler Event List</span>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          <Scheduler
            timeZone="Asia/Bangkok"
            dataSource={data}
            views={["month"]}
            defaultCurrentView="month"
            defaultCurrentDate={currentDate}
            height={580}
            editing={false}
            // onAppointmentClick={(e) => (e.cancel = true)}
            onAppointmentDblClick={(e) => (e.cancel = true)}
          >
            <Resource
              fieldExpr="priority"
              allowMultiple={true}
              useColorAsDefault={true}
              dataSource={PriorityColorData}
              label="Priority"
            />
          </Scheduler>
        </div>
      </div>
    </div>
  );
}
